import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router';
import RestaurantLayout from '../../components/Restaurant/RestaurantLayout';
import BonusQrCodeReader from '../../components/Bonus/BonusQrCodeReader';
import bonusProductAPI from '../../middleware/bonusProductAPI';
import AssignmentRoundedIcon from '@material-ui/icons/AssignmentRounded';
import DoneRoundedIcon from '@material-ui/icons/DoneRounded';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import ConfirmationNumberRoundedIcon from '@material-ui/icons/ConfirmationNumberRounded';
import PermContactCalendarRoundedIcon from '@material-ui/icons/PermContactCalendarRounded';
import { Button, Divider, Step, StepLabel, Stepper } from '@material-ui/core';
import Swal from 'sweetalert2';
import { isArray, join, filter, map, trim } from 'lodash';
import bonusAPI from '../../middleware/bonusAPI';
import { alertError } from '../../Util/Util';
import BonusProductBarcode from '../../components/Bonus/BonusProductBarcode';
import Loading from '../../components/Loading';

const STEPS = [
  {
    key: 'member',
    name: '會員',
  },
  {
    key: 'use',
    name: '使用',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#fff',
    padding: theme.spacing(3),
    maxWidth: '500px',
    margin: theme.spacing(0, 'auto'),
    borderRadius: theme.spacing(0.5),
  },
  block: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'stretch',
    gap: theme.spacing(2),
  },
  title: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
  },
  titleSubText: {
    fontSize: '0.9rem',
    color: theme.palette.text.secondary,
  },
  subTitle: {
    fontSize: '1.1rem',
    fontWeight: '600',
    margin: theme.spacing(1, 0),
    color: '#8b8b8b',
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  scanRsCounts: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'stretch',
    gap: theme.spacing(2),
    backgroundColor: '#eee',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
  },
  scanRs: {
    flexGrow: 1,
    flexBasis: '100%',
    overflowY: 'auto',
    maxHeight: '200px',
  },
  scanRsContent: {
    margin: theme.spacing(1, 0),
    fontSize: '0.8rem',
    fontWeight: '500',
    lineHeight: '1.5',
  },
  scanRsSuccess: {
    padding: theme.spacing(1),
    margin: theme.spacing(1, 0),
    borderRadius: theme.spacing(0.5),
    backgroundColor: '#6b936b',
    color: '#fff',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  scanRsError: {
    padding: theme.spacing(1),
    margin: theme.spacing(1, 0),
    borderRadius: theme.spacing(0.5),
    backgroundColor: '#e35858',
    color: '#fff',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  stepBtns: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    justifyContent: 'space-evenly',
    margin: theme.spacing(2, 0, 0),
  },
}));

const UseBonusProductQRCode = (props) => {
  const { externalMemberQRCode, withLayout = true } = props;
  const classes = useStyles();
  const history = useHistory();
  const [activeStep, setActiveStep] = useState(0);
  const [nowStep, setNowStep] = useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [scanQRCode, setScanQRCode] = React.useState('');
  const [scanRs, setScanRs] = React.useState([]);
  const [memberQRCode, setMemberQRCode] = useState('');
  const [useUser, setUseUser] = useState();
  const [bonusProduct, setBonusProduct] = useState();

  useEffect(() => {
    setNowStep(STEPS[activeStep]);
  }, [activeStep]);

  useEffect(() => {
    // 支援掃描會員 QRCODE 入口進入使用紙本券的流程
    if (trim(externalMemberQRCode) !== '') {
      setMemberQRCode(externalMemberQRCode);
    }
  }, [externalMemberQRCode]);

  useEffect(() => {
    if (scanQRCode) {
      setIsLoading(true);

      bonusProductAPI
        .qrcodeUse(scanQRCode, useUser ? useUser.userId : undefined)
        .then(
          (rs) => {
            let newScanRs = [...scanRs];

            newScanRs.unshift({
              status: 'success',
              message: `使用成功 ${scanQRCode}`,
            });

            setScanRs(newScanRs);

            Swal.fire({
              toast: true,
              position: 'bottom',
              icon: 'success',
              title: `使用成功 ${scanQRCode}`,
              timer: 1000,
              showConfirmButton: false,
            });

            if (trim(rs.barcode) !== '') {
              setBonusProduct(rs);
            } else {
              setBonusProduct(undefined);
            }
          },
          (error) => {
            const errorMessage = isArray(error.messages)
              ? join(error.messages, '<br />')
              : error;
            let newScanRs = [...scanRs];

            newScanRs.unshift({
              status: 'error',
              message: `使用失敗 ${scanQRCode}`,
              error: errorMessage,
            });

            setScanRs(newScanRs);

            Swal.fire({
              toast: true,
              position: 'bottom',
              icon: 'error',
              title: `使用失敗 ${scanQRCode}`,
              timer: 1000,
              showConfirmButton: false,
            });
          },
        )
        .then(() => {
          setIsLoading(false);
          setScanQRCode('');
        });
    }
  }, [scanQRCode]);

  useEffect(() => {
    if (trim(memberQRCode) !== '') {
      setIsLoading(true);

      bonusAPI
        .verifyQrcode(memberQRCode)
        .then(
          (rs) => {
            setUseUser(rs);
            nextStep();
          },
          (error) => {
            alertError(error);
          },
        )
        .then(() => {
          setIsLoading(false);
          setMemberQRCode('');
        });
    }
  }, [memberQRCode]);

  const handleChangeScanQRCode = (qrcodeData) => {
    if (qrcodeData) {
      setScanQRCode(qrcodeData);
    }
  };

  const handleChangeScanMemberQRCode = (qrcodeData) => {
    if (qrcodeData) {
      setMemberQRCode(qrcodeData);
    }
  };

  const nextStep = () => {
    const nextActiveStep = activeStep + 1;

    setActiveStep(nextActiveStep);

    Swal.fire({
      toast: true,
      position: 'center',
      icon: 'info',
      title: `進入 ${STEPS[nextActiveStep].name} 步驟`,
      timer: 1000,
      showConfirmButton: false,
    });
  };

  const prevStep = () => {
    const prevActiveStep = activeStep - 1;

    setActiveStep(prevActiveStep);

    if (STEPS[prevActiveStep].key === 'member') {
      setUseUser(undefined);
    }
  };

  const handleClickDoneStep = () => {
    history.push('/bonus');
  };

  return (
    <RestaurantLayout
      showBackBtn={!externalMemberQRCode}
      hideLogo={(nowStep && nowStep.key === 'use') || externalMemberQRCode}
      withLayout={withLayout}>
      <div className={classes.root}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {map(STEPS, (step) => (
            <Step key={step.key}>
              <StepLabel>{step.name}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {nowStep && nowStep.key === 'member' && (
          <div className={classes.block}>
            <div className={classes.title}>會員 QRCODE</div>

            {!isLoading && (
              <div>
                <BonusQrCodeReader
                  hideTitle
                  isLoading={isLoading}
                  verifyQrcodeData={handleChangeScanMemberQRCode}
                />
              </div>
            )}

            {isLoading && (
              <div style={{ height: '160px' }}>
                <Loading />
              </div>
            )}
          </div>
        )}

        {nowStep && nowStep.key === 'use' && (
          <div className={classes.block}>
            <div className={classes.title}>
              使用紙本優惠券
              <div className={classes.titleSubText}>
                多張使用時，可等待掃描結果出現後再繼續掃描下一張
                <br />
                LSS 開頭紙本券，直接輸入即可
              </div>
            </div>

            <div>
              <BonusQrCodeReader
                hideTitle
                isLoading={isLoading}
                verifyQrcodeData={handleChangeScanQRCode}
              />
            </div>

            <div>
              {bonusProduct && (
                <BonusProductBarcode bonusProduct={bonusProduct} />
              )}
            </div>

            <div>
              <div className={classes.subTitle}>
                <AssignmentRoundedIcon />
                目前掃描結果
              </div>

              <div className={classes.scanRsCounts}>
                <div>
                  <div>
                    <ConfirmationNumberRoundedIcon />
                  </div>
                  <div>全部 {scanRs.length} 筆</div>
                </div>

                <Divider orientation="vertical" flexItem />

                <div>
                  <div>
                    <DoneRoundedIcon />
                  </div>
                  <div>
                    成功{' '}
                    {filter(scanRs, (rs) => rs.status === 'success').length} 筆
                  </div>
                </div>

                <Divider orientation="vertical" flexItem />

                <div>
                  <div>
                    <ClearRoundedIcon />
                  </div>
                  <div>
                    失敗 {filter(scanRs, (rs) => rs.status === 'error').length}{' '}
                    筆
                  </div>
                </div>

                <div className={classes.scanRs}>
                  <Divider variant="middle" />

                  <div className={classes.scanRsContent}>
                    {scanRs.map((scan, index) => (
                      <div
                        key={index}
                        className={
                          scan.status === 'success'
                            ? classes.scanRsSuccess
                            : classes.scanRsError
                        }>
                        {scan.status === 'success' ? (
                          <DoneRoundedIcon />
                        ) : (
                          <ClearRoundedIcon />
                        )}

                        {scan.message}
                        {scan.error && <div>{scan.error}</div>}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {useUser && (
                <>
                  <div className={classes.subTitle}>
                    <PermContactCalendarRoundedIcon />
                    使用會員
                  </div>

                  <div className={classes.scanRsCounts}>
                    <div>UserId: {useUser.userId}</div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        <div className={classes.stepBtns}>
          {nowStep && nowStep.key === 'member' && (
            <Button
              variant="contained"
              color="default"
              fullWidth
              onClick={nextStep}>
              跳過
            </Button>
          )}

          {nowStep && nowStep.key === 'use' && (
            <>
              <Button
                variant="contained"
                color="default"
                fullWidth
                onClick={prevStep}>
                上一步
              </Button>

              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleClickDoneStep}>
                結束
              </Button>
            </>
          )}
        </div>
      </div>
    </RestaurantLayout>
  );
};

export default UseBonusProductQRCode;
